import React from 'react';

export const WidgetsStatusBadge = ({ sentiment }) => {
  const getStatusText = () => {
    switch (sentiment) {
      case 'upcoming':
        return 'Upcoming';
      case 'active':
        return 'Active';
      case 'completed':
        return 'Completed';
      default:
        return '';
    }
  };

  return (
    <div className={`status-badge ${sentiment} font-semibold`}>
      {getStatusText()}
    </div>
  );
};
